<div class="customize-fields__inner-container">
  @if (typeView !== 'translationsViewNoEditable' && typeView !== 'translationsViewEditable') {
    <field-type-list-simple
      	[field]="customizeFieldText.contentTypeInfo"
        [preSelectItem]="customizeFieldText.field.fieldContentTypeId"
        [listValues]="customizeFieldText.contentTypeList"
        (itemSelected)="itemSelected($event, 'fieldContentTypeId')">
    </field-type-list-simple>
    @if(concept?.allowPublicShare && field.fieldContentTypeId === 'emai' && typeView !== 'channelView'){
      <field-type-switch
        [field]="{label: 'customize.identification-mail'| afTranslate}"
        [small]="true"
        [preSelectItem]="customizeFieldText.field.isIdentifier"
        [disabled]="previewMode || field.noEditable || isPrivate || field.private || fieldContainer.multiple"
        (itemSelected)="itemSelected($event, 'isIdentifier')">
      </field-type-switch>
    }
  }
  @if (customizeFieldText.field.multiline) {
    <field-type-text-multiline [field]="customizeFieldText.defaultValueInfo"
      [preSelectItem]="customizeFieldText.field.defaultValue"
      (itemSelected)="itemSelected($event, 'defaultValue')">
    </field-type-text-multiline>
  }
  @else {
    <field-type-text-simple [field]="customizeFieldText.defaultValueInfo"
      [preSelectItem]="customizeFieldText.field.defaultValue"
      (itemSelected)="itemSelected($event, 'defaultValue')">
    </field-type-text-simple>
  }
  @if (typeView !== 'translationsViewNoEditable' && typeView !== 'translationsViewEditable') {
    <div class="customize-fields-switch-form__container">
      <customize-fields-switch-form
        [field]="customizeFieldText.field"
        [small]="true"
        [concept]="concept"
        [isPrivate]="isPrivate"
        [hiddenInLandings]="hiddenInLandings"
        [typeView]="typeView"
        [previewMode]="previewMode"></customize-fields-switch-form>
      <field-type-switch
        [field]="{label: 'customize.multiline'| afTranslate}"
        [small]="true"
        [preSelectItem]="customizeFieldText.field.fieldContentTypeId !== 'addr' && customizeFieldText.field.multiline"
        [disabled]="customizeFieldText.field.fieldContentTypeId == 'addr' || customizeFieldText.disabledFormConfiguration"
        (itemSelected)="itemSelected($event, 'multiline')">
      </field-type-switch>
    </div>
  }
  @if(concept.communicationChannel && customizeFieldText.field.multiline){
    @if (typeView !== 'translationsViewNoEditable' && typeView !== 'translationsViewEditable') {
      <div class="customize-fields-switch-form__container">
        <field-type-switch
          [field]="{label: 'customize.voice-record'| afTranslate}"
          [small]="true"
          [preSelectItem]="customizeFieldText.field.isVoiceRecord"
          [disabled]="customizeFieldText.disabledFormConfiguration"
          (itemSelected)="itemSelected($event, 'isVoiceRecord')">
        </field-type-switch>
        @if(customizeFieldText.field.isVoiceRecord){
          <field-type-switch
            [field]="{label: 'customize.voice-record-to-text'| afTranslate}"
            [small]="true"
            [preSelectItem]="customizeFieldText.field.voiceRecordOk"
            [disabled]="customizeFieldText.disabledFormConfiguration"
            (itemSelected)="itemSelected($event, 'voiceRecordOk')">
          </field-type-switch>
        }
      </div>
    }
    @if(customizeFieldText.field.isVoiceRecord && customizeFieldText.field.voiceRecordOk){
      <field-type-text-simple
          [field]="customizeFieldText.voiceRecordInput"
          [preSelectItem]="customizeFieldText.field.voiceRecordOkText"
          (itemSelected)="itemSelected($event, 'voiceRecordOkText')">
      </field-type-text-simple>
    }
  }
</div>
